import { render } from "./DataTableToolbar.vue?vue&type=template&id=48b4ed22"
import script from "./DataTableToolbar.vue?vue&type=script&lang=js"
export * from "./DataTableToolbar.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/service/service-cp-company/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__